import { motion } from "framer-motion";
import React from "react";
import { container2, item2 } from "./animation";
import { Github2 } from "./Icons/Github2";
import { Instagram } from "./Icons/Instagram";
import { Linkedin } from "./Icons/Linkedin";

function SocialLinks() {
  return (
    <>
      <motion.div
        className="social--links"
        variants={container2}
        initial="hidden"
        animate="visible"
        exit={{
          opacity: 0,
          transition: {
            delay: 0.7,
            when: "afterChildren",
          },
        }}
      >
        <motion.a
          href="https://github.com/yadprab"
          target="_blank"
          rel="noOpener noReferrer"
          variants={item2}
        
          exit={{
            opacity: 0,
            scale: 0,

            transition: {
              delay: 0.2,
            },
          }}
        >
          <Github2 />
        </motion.a>
        <motion.a
          href="https://www.instagram.com/yad_dev_design/"
          target="_blank"
          rel="noOpener noReferrer"
          variants={item2}
          exit={{
            opacity: 0,
            scale: 0,

            transition: {
              delay: 0.4,
            },
          }}
        >
          <Instagram />
        </motion.a>
        <motion.a
          href="https://www.linkedin.com/in/yathavan-prabhakar-b04181202/"
          target="_blank"
          rel="noOpener noReferrer"
          variants={item2}
          exit={{
            opacity: 0,
            scale: 0,

            transition: {
              delay: 0.5,
            },
          }}
        >
          <Linkedin />
        </motion.a>
      </motion.div>
    </>
  );
}

export { SocialLinks };
